export default __webpack_public_path__ + "images/1228028a221df306981d0ef16b6e414f.svg";